"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceNumberingSelector = class UcInvoiceNumberingSelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    options;
    onOptions(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("options");
    }
    selectedID;
    async $$load_selectedID() {
        return this.value.id;
    }
    ux;
    dataMembers = ['selectedID', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedID: null,
                ux: null,
            },
        };
    }
    async act_5962862420439144_script_7240_getActionArgs_value($event) {
        console.log($event, this.selectedID);
    }
    async act_5962862420439144_script_7240_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_7240_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_input_7239_getWhen($event) {
        return this.value.id !== this.selectedID;
    }
    async act_5962862420439144_request_7242_getActionArgs($event) {
        return {
            operation: "update_invoice",
            data: { id: this.invoice.id, etag: this.invoice.etag, numbering_id: this.selectedID },
        };
    }
    async evh_5962862420439144_input_7241_getWhen($event) {
        return this.value.id !== this.selectedID;
    }
    async evh_5962862420439144_input(event, scope) {
        return await this.actions.evh_5962862420439144_input.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_5962862420439144_script_7240 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_7240_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_input_7239 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_7240,
            event: "input",
            when: this.evh_5962862420439144_input_7239_getWhen,
            displayName: "script",
        });
        const act_5962862420439144_request_7242 = new core_1.actions.RequestAction({
            actionArgs: this.act_5962862420439144_request_7242_getActionArgs,
            displayName: "saveSelection",
            events: [],
        });
        const evh_5962862420439144_input_7241 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_request_7242,
            event: "input",
            when: this.evh_5962862420439144_input_7241_getWhen,
            displayName: "saveSelection",
        });
        const evh_5962862420439144_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_input_7239, evh_5962862420439144_input_7241],
        });
        return {
            act_5962862420439144_script_7240,
            evh_5962862420439144_input_7239,
            act_5962862420439144_request_7242,
            evh_5962862420439144_input_7241,
            evh_5962862420439144_input,
            saveSelection: act_5962862420439144_request_7242,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceNumberingSelector.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceNumberingSelector.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceNumberingSelector.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceNumberingSelector.prototype, "onValue", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Array,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], UcInvoiceNumberingSelector.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('options'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceNumberingSelector.prototype, "onOptions", null);
UcInvoiceNumberingSelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceNumberingSelector);
exports.default = UcInvoiceNumberingSelector;
vue_property_decorator_1.Vue.component("UcInvoiceNumberingSelector", UcInvoiceNumberingSelector);
